/* global axios */
// import ApiClient from './ApiClient';
import CacheEnabledApiClient from './CacheEnabledApiClient';

export class TeamsAPI extends CacheEnabledApiClient {
  constructor() {
    super('teams', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'team';
  }

  // eslint-disable-next-line class-methods-use-this
  extractDataFromResponse(response) {
    return response.data;
  }

  // eslint-disable-next-line class-methods-use-this
  marshallData(dataToParse) {
    return { data: dataToParse };
  }

  getAgents({ teamId }) {
    return axios.get(`${this.url}/${teamId}/team_members`);
  }

  addAgents({ teamId, members }) {
    // GK-HUB: payload estruturado members[{ user_id, receives_assignment }]
    return axios.post(`${this.url}/${teamId}/team_members`, { members });
  }

  updateAgents({ teamId, members }) {
    // GK-HUB: payload estruturado members[{ user_id, receives_assignment }]
    return axios.patch(`${this.url}/${teamId}/team_members`, { members });
  }

  // GK-HUB (#115): remoção ALVO por user_id (DELETE) — remove SÓ os agentes informados. Substitui o
  // padrão fetch-then-replace (updateAgents com a lista restante), que tinha race de lost-update E
  // mandava members:[] ao remover o último membro → 422 do guard anti-wipe. O destroy do controller
  // normaliza user_ids → remove_members; validate_members_payload sai cedo (sem chave :members).
  removeAgents({ teamId, userIds }) {
    return axios.delete(`${this.url}/${teamId}/team_members`, {
      data: { user_ids: userIds },
    });
  }
}

export default new TeamsAPI();
